export default function CtaSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Energetic%20modern%20shopping%20scene%20with%20diverse%20fashion%20items%20displayed%20on%20geometric%20shelving%20unit%2C%20colorful%20sneakers%20handbags%20and%20accessories%20arranged%20artfully%2C%20bright%20cheerful%20retail%20boutique%20interior%20with%20natural%20light%20streaming%20through%20large%20windows%2C%20vibrant%20coral%20pink%20and%20emerald%20green%20color%20accents%20against%20white%20walls%2C%20contemporary%20lifestyle%20retail%20photography%2C%20dynamic%20composition%20with%20playful%20energy%20and%20visual%20excitement&width=1600&height=900&seq=cta-full-v2-2026&orientation=landscape"
          alt="Superbuy Spreadsheet - start shopping smarter today"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <h2 className="font-heading text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 tracking-wide">
          START SHOPPING SMARTER
        </h2>
        <p className="text-background-50/80 text-sm md:text-lg leading-relaxed mb-10 max-w-xl mx-auto">
          Browse curated Superbuy spreadsheets
          <br />
          and discover the best deals today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-4 px-8 py-4 rounded-full bg-primary-800 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-900 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
            </span>
            <span>BUY IT NOW</span>
            <i className="ri-arrow-right-up-line text-background-50/70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-8 py-4 rounded-full border-2 border-background-50/50 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            SUPERBUY SHEET
          </a>
        </div>
      </div>
    </section>
  );
}